import { render, staticRenderFns } from "./RegistrationDetailsHeader.vue?vue&type=template&id=6a87725b"
import script from "./RegistrationDetailsHeader.vue.ts?vue&type=script&lang=ts&external"
export * from "./RegistrationDetailsHeader.vue.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports